import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import http from '@xmatters/redux/store/middleware/http';
import httpError from '@xmatters/redux/store/middleware/httpError';
import broadcast from '@xmatters/redux/store/middleware/broadcast';

import combinedReducers from 'reducers';

import dismissedAlertsEnhancer from './enhancers/dismissedAlerts';
import tableEnhancer from './enhancers/table';
import flowDesignerEnhancer from './enhancers/flowDesigner';
import savedSearches from './enhancers/savedSearches';
import workflowsEnhancer from './enhancers/workflows';
import allEventsEnhancer from './enhancers/allEvents';
import upgradeCompleteEnhancer from './enhancers/upgradeComplete';
import helpViewEnhancer from './enhancers/helpView';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle
let globalStore;

export default function configureStore(initialState = {}) {
  const enhancers = [
    dismissedAlertsEnhancer,
    tableEnhancer,
    flowDesignerEnhancer,
    workflowsEnhancer,
    allEventsEnhancer,
    upgradeCompleteEnhancer,
    helpViewEnhancer,
    savedSearches,
    applyMiddleware(thunk, http, httpError, broadcast),
  ];

  globalStore = createStore(
    combinedReducers,
    initialState,
    composeEnhancers(...enhancers),
  );

  return globalStore;
}

export function exposeStoreToGwt(store) {
  window.XM_REDUX_STORE = store;

  // Make store available in window object
  const dispatchReduxAction = (type, payload) => {
    store.dispatch({ type, payload });
  };

  // unfold is defined under alarmpoint-body.xsl @ line 276
  if (window.XM_dispatchReduxAction && window.XM_dispatchReduxAction.unfold) {
    window.XM_dispatchReduxAction.unfold(dispatchReduxAction);
  } else {
    window.XM_dispatchReduxAction = dispatchReduxAction;
  }
}

export const getGlobalStore = () => globalStore;
